// // src/app/constants/date-keys.ts
// export const TimeZonePipeISTrue: string[] = [
//   'created_at',
//   'canceled_date',
//   'end',
//   'start',
//   'end_time',
//   'send_time',
//   'start_time'
// ];

export const TimeZonePipeISFalse: string[] = [
  'end_time',
  'start_time',
  'end',
  'start'
];